import { apiClient } from '@/lib/api-client';
import type { User } from '@/types/user';

export interface MfaStats {
  total: number;
  enrolled: number;
  required: number;
  non_compliant: number;
}

export interface BulkMfaResult {
  requested: number;
  succeeded: string[];
  skipped: { id: string; reason: string }[];
  failed: { id: string; error: string }[];
}

export const mfaService = {
  setMfaRequired(userId: string, required: boolean) {
    return apiClient<User>(`/users/${userId}/mfa-required`, {
      method: 'PATCH',
      body: { mfa_required: required },
    });
  },

  enableTotpForUser(userId: string) {
    return apiClient<{ message: string }>('/auth/totp/enable-user', {
      method: 'POST',
      body: { user_id: userId },
    });
  },

  disableTotpForUser(userId: string) {
    return apiClient<{ message: string }>('/auth/totp/disable-user', {
      method: 'DELETE',
      body: { user_id: userId },
    });
  },

  getStats(tenantId?: string) {
    const qs = tenantId ? `?tenant_id=${encodeURIComponent(tenantId)}` : '';
    return apiClient<MfaStats>(`/users/stats/mfa${qs}`);
  },

  bulkRequire(body: { role: string; skip_already_required?: boolean; tenant_id?: string }) {
    return apiClient<BulkMfaResult>('/users/mfa-required/bulk', {
      method: 'POST',
      body,
    });
  },
};
